import React from 'react';
import { Modelling } from 'src/features/MM/components/templates/Modelling';
import { Page } from '../../components/molecules/Page';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const ModellingPage: React.FC = () => {
  return (
    <Page
      filterBar={<FilterBar includeAggregation />}
      pageTitle="Modelling"
      pageSubtitle="Track your project and goal with full information"
      extraButtons={<GenAIActionButtons />}>
      <Modelling />
    </Page>
  );
};
